import React from "react";
import TagsAtentus from "./TagsAtentus";

export const FilterTags = ({ etiquetas, updateEtiquetas,  directToPopover, directAnchorEl, tagsId, preload, filterTagsType, showFilterType }) => {
  return (
    <div>
      <TagsAtentus
        etiquetas={etiquetas || []}
        updateEtiquetas={updateEtiquetas}
        directToPopover={directToPopover}
        directAnchorEl={directAnchorEl}
        tagsId={tagsId}
        preload={preload}
        filterTagsType={filterTagsType}
        showFilterType={showFilterType}
      />
    </div>
  );
};
